<div class="fondo">

    <div class="texts animate__animated animate__backInUp animate__slow">
        <h1>Certificaciones</h1>
        <p> Nuestros productos cumplen con todos los estándares de certificación que exigen las Normas Chilenas vigentes, para los sistemas de andamiaje. <br> Certificaciones otorgadas por instituciones externas calificadas y acreditadas, especialmente para estos efectos. </p>
    </div>
    <div class="imgs">
        <img src="/assets/collage-certificaciones.jpg" alt="">
    </div>
    </div>